import React from 'react';
import {Typography} from '@mui/material';
import {translations} from 'presentation/translations-new';
import {StyledStack} from './styles';

const {
	title,
	analysisTitle,
	section1,
	section2,
	section3,
	descSection1,
	descSection2,
	descSection3,
} = translations['pt-br'].privateFlow.requestAuthorizations.modalFinish.returnPeriodMessage;

type ReturnPeriodMessageProps = {
	useAnalysisTitle?: boolean;
};

const ReturnPeriodMessage = ({useAnalysisTitle = false}: ReturnPeriodMessageProps) => (
	<StyledStack>
		<Typography variant="subtitle2">{useAnalysisTitle ? analysisTitle : title}</Typography>
		<div>
			<Typography variant="subtitle2">{section1}</Typography>
			<Typography variant="body2">{descSection1}</Typography>
		</div>
		<div>
			<Typography variant="subtitle2">{section2}</Typography>
			<Typography variant="body2">{descSection2}</Typography>
		</div>
		<div>
			<Typography variant="subtitle2">{section3}</Typography>
			<Typography variant="body2">{descSection3}</Typography>
		</div>
	</StyledStack>
);

export {ReturnPeriodMessage};
